import { Reducer } from 'redux';
import {
  CONTENT_LIB_SET_CHANNELS_ACTION,
  CONTENT_LIB_SET_SEARCH_FILTER_ACTION,
  CONTENT_LIB_SET_VIDEOS_SEARCH_RESULT_EXIST_ACTION,
  IContentLibState,
  TContentLibActions
} from './types';
import { EUserLevel } from '../general/types';

const initialState: IContentLibState = {
  searchFilter: {
    targetLangCode: '',
    nativeLangCode: '',
    text: '',
    level: EUserLevel.UNKNOWN
  },
  channels: null as any,
  videosSearchResultExist: false
};

export const contentLibReducer: Reducer<IContentLibState, TContentLibActions> = (
  state = initialState,
  action
) => {

  switch (action.type) {
    case CONTENT_LIB_SET_VIDEOS_SEARCH_RESULT_EXIST_ACTION:
      return {
        ...state,
        videosSearchResultExist: action.exist,
      };
    case CONTENT_LIB_SET_SEARCH_FILTER_ACTION:
      return {
        ...state,
        searchFilter: {...state.searchFilter, ...action.searchFilter}
      };
    case CONTENT_LIB_SET_CHANNELS_ACTION:
      return {
        ...state,
        channels: action.channels,
      };

    default:
      return state;
  }
};
